// quickbuy-handler.js
(function() {
    'use strict';
  
    // Handle quickbuy button clicks and active states
    document.addEventListener('click', (event) => {
      // Check if the clicked element is the `.quickbuy-add` button
      const quickBuyButton = event.target.closest('.quickbuy-add');
  
      if (quickBuyButton) {
        // Find the nearest `.product-card__quickadd` wrapper
        const productCardQuickAdd = quickBuyButton.previousElementSibling;
  
        // If `.product-card__quickadd` exists, add the active class
        if (productCardQuickAdd && productCardQuickAdd.classList.contains('product-card__quickadd')) {
          productCardQuickAdd.classList.add('active');
        }
  
        // Stop event propagation to prevent triggering the document click handler
        event.stopPropagation();
        return;
      }
  
      // Handle clicks outside: remove 'active' class from all `.product-card__quickadd` elements
      document.querySelectorAll('.product-card__quickadd.active').forEach((quickAddElement) => {
        quickAddElement.classList.remove('active');
      });
    });
  
    // Global add to cart function
    window._addMeToCart = function(e, el) {
      e = e || window.event;
      e.preventDefault();
      
      const variantIdAdded = el.dataset.variant_id;
      const productIdAdded = el.dataset.product_id;
      
      // Dispatch product added event
      document.dispatchEvent(new CustomEvent("product:added", {
        bubbles: true,
        detail: {
          productID: productIdAdded
        }
      }));
  
      // Add check for product-page-quickbuy-swatch class
      if (el.classList.contains('product-page-quickbuy-swatch')) {
        console.log('product-page-quickbuy-swatch');
        
        // Find variant picker in main product form
        const productVariantPicker = document.querySelector('.product .variant-picker');
        if (productVariantPicker) {
          const variantInputs = productVariantPicker.querySelectorAll('input');
          
          // Check each input for matching variant ID
          variantInputs.forEach(input => {
            const inputVariantId = input.getAttribute('data-variant-id');
            console.log(inputVariantId, variantIdAdded);
            if (inputVariantId === variantIdAdded) {
              console.log('Found matching variant:', inputVariantId);
              console.log(input);
              input.click();
            }
          });
        }
      }
  
      // Prepare form data for cart API
      let formData = {
        'items': [
          {
            'id': el.dataset.variant_id,
            'quantity': 1
          }
        ]
      };
  
      // Add to cart via Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        // First dispatch cart:refresh
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
  
        // Then set up the completion listener
        const cartRefreshComplete = () => {
          // Handle completion here
          console.log('Cart refresh completed');
        
          const cartDrawer = document.querySelector('#cart-drawer');
          if (variantIdAdded && cartDrawer) {
            const lineItems = cartDrawer.querySelectorAll('.line-item');
            lineItems.forEach(item => {
              const variantId = item.getAttribute('data-variant-id');
              if (variantId === variantIdAdded) {
                item.classList.add('show-line-item');
              } else {
                item.classList.remove('show-line-item');
              }
            });
          }
        };
        
        document.addEventListener('cart:content:rendered', cartRefreshComplete);
      })
      .catch((err) => {
        console.error('Error: ' + err);
        
        // Optionally show user-friendly error message
        const errorMessage = 'Unable to add item to cart. Please try again.';
        
        // Check if theme has a notification system
        if (window.theme && window.theme.showNotification) {
          window.theme.showNotification(errorMessage, 'error');
        } else {
          // Fallback alert
          alert(errorMessage);
        }
      });
    };
  
    // Initialize quickbuy functionality when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuickbuy);
    } else {
      initQuickbuy();
    }
  
    function initQuickbuy() {
      // Add any additional initialization here if needed
      console.log('Quickbuy handler initialized');
      
      // Ensure quickbuy buttons are properly bound
      document.querySelectorAll('[onclick*="_addMeToCart"]').forEach(button => {
        // Remove inline onclick and add proper event listener
        const onclickAttr = button.getAttribute('onclick');
        if (onclickAttr) {
          button.removeAttribute('onclick');
          button.addEventListener('click', function(e) {
            window._addMeToCart(e, this);
          });
        }
      });
    }
  
    // Re-initialize when new products are loaded (infinite scroll, filters, etc.)
    document.addEventListener('products:loaded', initQuickbuy);
    document.addEventListener('collection:reloaded', initQuickbuy);
  
  })();